import { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Logo from "../../../assets/img/logo.png";
import { Box, Button, Menu, MenuItem, TextField, InputAdornment } from "@mui/material";
import debounce from "lodash.debounce";
import Acessibilidade from "./components/Acessibilidade";
import DrawerMenu from "./components/drawer";
import SearchIcon from "@mui/icons-material/Search";
import api from "../../../services/api/api";
import { useNavigate } from "react-router-dom";

const AppBarComponent = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState({});
  const [, setDrawerOpen] = useState(false);
  const [publicacoesItens, setPublicacoesItens] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Lidar com o scroll da página
  useEffect(() => {
    const handleScroll = debounce(() => {
      setIsScrolled(window.scrollY > 100);
    }, 50);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchPublicacoesCategorias = async () => {
    try {
      const response = await api.get("api/categories");
      if (response.data) {
        const categorias = response.data.map((categoria) => ({
          label: categoria.name,
          to: `/publicacoes/${categoria.name}`,
        }));
        setPublicacoesItens(categorias);
      }
    } catch (error) {
      console.error("Erro ao buscar categorias de publicações:", error.message);
    }
  };

  useEffect(() => {
    fetchPublicacoesCategorias();
  }, []);

  // Função de navegação para outras páginas
  const handleNavigation = (path) => {
    window.location.href = path;
  };

  const handleMenuOpen = (event, menu) => {
    setMenuAnchor({ ...menuAnchor, [menu]: event.currentTarget });
  };

  const handleMenuClose = (menu) => {
    setMenuAnchor({ ...menuAnchor, [menu]: null });
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // Função de pesquisa com clique ou Enter
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const handleSearchSubmit = () => {
    if (searchQuery.trim()) {
      navigate(`/search-results?q=${searchQuery}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  const navItems = [
    { label: "A Câmara", id: "acamara" },
    { label: "Notícias", to: "/noticias" },
    {
      label: "Portal da Transparência",
      to: "https://cmserracaiadarn.transparencia.topsolutionsrn.com.br/",
    },
    { label: "Publicações", id: "publicacoes" },
    { label: "Vereadores", id: "vereadores" },
    { label: "OUVIDORIA", to: "/faleconosco" },
  ];

  const vereadoresItens = [
    { label: "Cris Azevedo", to: "/vereadores/crisazevedo" },
    { label: "Edilmo Lira", to: "/vereadores/edilmolira" },
    { label: "Erivan Elias da Silva", to: "/vereadores/erivanelias" },
    { label: "Jailson Mendonça da Silva", to: "/vereadores/jailsonmendonca" },
    { label: "Janaína Patrícia Bezerra da Silva", to: "/vereadores/janainabezerra" },
    { label: "Leandro Euclides Guedes da Costa", to: "/vereadores/leandroeuclides" },
    { label: "Marcia Costa Araujo Gomes", to: "/vereadores/marciacosta" },
    { label: "Ovídio de Aquino e Silva Neto", to: "/vereadores/ovidiodeaquino" },
    { label: "Wagner Ferreira Gonçalves", to: "/vereadores/wagnerferreira" },
  ];

  return (
    <header
      style={{
        color: "#fff",
        fontFamily: "Arial, sans-serif",
        position: "fixed",
        top: 0,
        zIndex: 2,
        width: "100vw",
        transition: "all 0.3s ease",
      }}
    >
      <Acessibilidade />

      <Box
        sx={{
          display: "flex",
          opacity: isScrolled ? 0 : 1,
          visibility: isScrolled ? "hidden" : "visible",
          height: isScrolled ? 0 : "auto",
          transition:
            "opacity 0.3s ease, visibility 0.3s ease, height 0.3s ease",
          flexWrap: "wrap",
          background: "#fff",
          padding: "40px",
          gap: "40px",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <a href="/">
          <img
            src={Logo}
            alt="Timbre do municipio"
            style={{ height: "100px" }}
          />
        </a>
        <Box style={{ display: "flex", gap: "8px", height: "50%" }}>
          <Button
            href="https://esic-cmserracaiada.prosipe.com/index/"
            style={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.text,
              padding: "8px 16px",
              borderRadius: "4px",
            }}
          >
            E-SIC
          </Button>
          <Button
            href="http://170.82.253.129:8080/cmcontracheque/"
            style={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.text,
              padding: "8px 16px",
              borderRadius: "4px",
            }}
          >
            CONTRACHEQUE ONLINE
          </Button>

          <Box
            sx={{
              display: isSmallScreen ? "none" : "flex",
              gap: "8px",
              height: "50%",
            }}
          >
            <TextField
              variant="outlined"
              placeholder="Pesquisar..."
              size="small"
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleKeyPress}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Button onClick={handleSearchSubmit} sx={{minWidth:"50px",padding:"7px 8px",background:theme.palette.primary.main}}>
                      <SearchIcon sx={{ color:theme.palette.primary.text }} />
                    </Button>
                  </InputAdornment>
                ),
              }}
              sx={{
                width: "250px",
                "& .MuiInputBase-input": {
                  color: "black",
                },
                "& .MuiInputBase-root":{
                  padding: 0
                },
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width:"100vw",
          display: "flex",
          height: "6vh",
          justifyContent: { xs: "flex-start", md: "center" },
          alignItems: "center",
          gap: "10px",
          padding: "30px 16px ",
          marginTop: isScrolled ? "-80px" : "0px",
          backgroundColor: theme.palette.primary.subMain,
          transition: "margin-top 0.3s ease",
        }}
      >
        <DrawerMenu
          color="inherit"
          edge="start"
          onClick={toggleDrawer(true)}
          sx={{
            display: { xs: "block", md: "none", color: theme.palette.primary.text },
          }}
        />

        <nav
          style={{
            display: isSmallScreen ? "none" : "flex",
            gap: "16px",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {navItems.map((item) =>
            item.id ? (
              <Box
                key={item.label}
                sx={{ position: "relative", display: "inline-block" }}
              >
                <Button
                  sx={{
                    textDecoration: "none",
                    color: theme.palette.primary.text,
                    textTransform: "uppercase",
                  }}
                  onClick={(event) => handleMenuOpen(event, item.id)}
                >
                  {item.label}
                </Button>
                <Menu
                  anchorEl={menuAnchor[item.id]}
                  open={Boolean(menuAnchor[item.id])}
                  onClose={() => handleMenuClose(item.id)}
                >
                  {item.id === "acamara" && (
                    <>
                      <MenuItem
                        onClick={() => handleNavigation("/mesadiretora")}
                      >
                        Mesa diretora
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleNavigation("/institucional")}
                      >
                        Institucional
                      </MenuItem>
                    </>
                  )}
                  {item.id === "publicacoes" && (
                    <>
                      {publicacoesItens.map((publicacao) => (
                        <MenuItem
                          key={publicacao.label}
                          onClick={() => handleNavigation(publicacao.to)}
                        >
                          {publicacao.label}
                        </MenuItem>
                      ))}
                    </>
                  )}
                  {item.id === "vereadores" && (
                    <>
                      {vereadoresItens.map((vereador) => (
                        <MenuItem
                          key={vereador.label}
                          onClick={() => handleNavigation(vereador.to)}
                        >
                          {vereador.label}
                        </MenuItem>
                      ))}
                    </>
                  )}
                </Menu>
              </Box>
            ) : (
              <Button
                key={item.label}
                sx={{
                  textDecoration: "none",
                  color: theme.palette.primary.text,
                  textTransform: "uppercase",
                }}
                href={item.to}
              >
                {item.label}
              </Button>
            )
          )}
        </nav>
      </Box>
    </header>
  );
};

export default AppBarComponent;